import { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from 'constants/interfaces'
import { CHAT, handleGetPosts } from 'redux/actions/feed'

export const usePersonalViewChats = () => {
  const dispatch = useDispatch()
  const { chats, chatsFetching } = useSelector((state: RootState) => state.feed ?? [])
  const { isConfigReady } = useSelector((state: RootState) => state.config)
  const hasInitiatedFetchRef = useRef(false) // Флаг, что фетч был инициирован

  // Загрузка чатов только один раз
  useEffect(() => {
    if (hasInitiatedFetchRef.current || !isConfigReady || chats.length > 0) return

    hasInitiatedFetchRef.current = true

    const handleGetPostsParams = {
      type: CHAT,
      ts: Math.floor(new Date().getTime() / 1000).toString(),
      is_init: true,
      isRefresh: true,
    }

    dispatch(handleGetPosts(handleGetPostsParams))
  }, [dispatch, isConfigReady, chats.length])

  return {
    chats,
    allChatsLoaded: true, // Всегда считаем, что загрузка завершена после первой загрузки
    chatsFetching,
  }
}
